export class LoadProjectPHPStatisticsError extends Error {}
